export default __webpack_public_path__ + "static/media/DNo.20-2.9260b037.jpg";